import { SmartTable } from '../../../../components/smart-table/smart-table.model';

export class Controller {

    /** @ngInject */
    constructor($state, Alert, SoftwareLicenseManagementService) {
        this.$state = $state;
        this.Alert = Alert;
        this.SoftwareLicenseManagementService = SoftwareLicenseManagementService;
    }

    $onInit() {
        this.st = new SmartTable();
        this.samlAppLogo = window.env.urls.samlAppLogo;
        this.slmiDTO = {};
    }

    chooseApp() {
        this.selectedApp = this.st.selectedItems[0];        
    }

    goBack(){
        window.history.back();
    }

    isFormFilled() {
        return this.slmiDTO.description || this.slmiDTO.licenseCount || this.slmiDTO.licenseCost || this.slmiDTO.renewalDate;
    }


    save() {
        this.slmiDTO.applicationId = this.selectedApp.id;
        this.isSaving = true;
        this.SoftwareLicenseManagementService
            .createSoftwareLicenseManagementInfo(this.companyId, this.slmiDTO)
            .then(() => this.$state.go('^', {}, {reload: 'company.software-license-management'}))
            .then(() => this.Alert('success', 'global.messages.operation-successful'))
            .finally(() => this.isSaving = false)
    }
}



// WEBPACK FOOTER //
// ./src/portal/states/company/software-license-management/add/software-license-management-add.controller.js